<script>
  export default{
    saveUsername (username) {
      localStorage.setItem('username',username);
    },
    saveUserId(userId) {
      localStorage.setItem('userId',userId);
    },
    saveToken(token) {
      localStorage.setItem('token',token);
    },
    getUsername() {
      return localStorage.getItem("username");
    },
    getToken() {
      return localStorage.getItem("token");
    },
    getUserId() {
      return localStorage.getItem("userId");
    },
    isLogin() {
      if (localStorage.getItem("userId")) {
        return true;
      }
      return false;
    },
    logout() {
      localStorage.removeItem('username');
      localStorage.removeItem('userId');
    }
  }
</script>



// WEBPACK FOOTER //
// src/Utils.vue